<div id="curriculumContainer" class="d-flex flex-column" *ngIf="isOpen">
  <div class="curriculumContainer-header modal-header d-flex align-items-center">
    <h5 class="modal-title cs-modal-title mr-auto">Insert Curriculum Problem</h5>
    <button class="close ml-auto" (click)="close()">
      <i class="fa fa-times"></i>
    </button>
  </div>
  <div id="curriculumContainerContent" class="text-center">
    <div class="spinner-border text-primary my-4" role="status" *ngIf="isLoading; else topics">
      <span class="sr-only">Loading...</span>
    </div>

    <ng-template #topics>
      <div *ngFor="let t of topic?.children" class="text-left">
        <div class="d-flex">
          <div class="icon-box">
            <a href="javascript:void(0)" *ngIf="t.children.length > 0" (click)="t.show = !t.show">
              <img src="assets/img/plus_expand.png" *ngIf="!t.show">
              <img src="assets/img/minus_collapse.png" *ngIf="t.show">
            </a>
          </div>
          <div><a href="javascript:void(0)" class="title" (click)="t.show = !t.show">{{t.title}}</a></div>
        </div>
        <div [hidden]="!t.show" class="sub-list">
          <div *ngFor="let child of t.children"><a href="javascript:void(0)" (click)="openTopic(child.id)" class="title">{{child.title}}</a></div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
